<template>
  <div>
    <old-record-whitelist-main></old-record-whitelist-main>
  </div>
</template>

<script>
import OldRecordWhitelistMain from "@/components/admin/oldRecordWhitelist/oldRecordWhitelistMain";
export default {
  name: "oldRecordWhitelistMainView",
  components: { OldRecordWhitelistMain },
};
</script>

<style scoped></style>
